<template>
  <div class="activity" :class="`valign-${vertical}`">
    <b-navbar type="dark" variant="info" sticky>
      <b-navbar-brand href="#" style="z-index: 9999;">
        <router-link :to="back" v-if="back" class="arrow-back">
          <i class="fa fa-arrow-left"></i>
          <font-awesome-icon icon="arrow-left"></font-awesome-icon>
        </router-link>
        {{ title }}
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" v-if="!isLogin"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav v-if="!isLogin">
        <b-navbar-nav class="ml-auto">
          <app-confirm id="confirm-logout" :title="t('app.logout.title')" :message="t('app.logout.confirm')"
                       :button-ok="t('app.logout.btn-ok')" :button-cancel="t('app.logout.btn-cancel')" @ok="onLogout">
            <b-nav-item href="#" v-b-modal.confirm-logout>
              {{ t('app.logout.title') }}
            </b-nav-item>
          </app-confirm>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container fluid="md">
      <div class="content m-3">
        <slot></slot>
      </div>
    </b-container>
  </div>
</template>

<script>
import AppConfirm from "@/app/components/general/AppConfirm.vue";

export default {
  components: {AppConfirm},
  props: {
    title: { type: String, required: true },
    vertical: { type: String, default: 'top', description: 'Vertical alignment (top|center)' },
    fullSize: { type: Boolean, default: false },
    back: { type: Object, default: null }
  },

  setup() {
    // eslint-disable-next-line no-undef
    const { t } = useI18n()

    // eslint-disable-next-line no-undef
    const store = useStore()

    // eslint-disable-next-line no-undef
    const router = useRouter()

    const isLogin = router.currentRoute.name === 'Forbidden'

    const onLogout = () => {
      store.dispatch('AUTH_LOGOUT')
      router.push({ name: 'Forbidden' })
    }

    return {
      t,
      isLogin,
      onLogout,
    }
  }
}
</script>

<style lang="scss">
.activity {
  --activity-height: calc(100vh - 30px - 56px);
  background: #efefef;

  min-height: 100vh;

  a.navbar-brand {
    cursor: default;
  }

  .arrow-back {
    display: inline-block;
    color: #fff;
    padding: 0 10px 0 0;
  }

  & > .container {
    &:not(.without-space) {
      padding: 15px;
      min-height: calc(100vh - 56px);
    }
    &.without-space {
      margin: 0;
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.valign-center > .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
